'use client'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { setLanguage } from './language-menu.actions'
import { languages } from '@/localization/localization.config'
import { Language } from '@/localization/localization.types'
import { useOptimistic, useTransition } from 'react'
import { useDictionary } from '../../navigation.dictionary'

interface LanguageMenuProps {
  lang: Language
}

const LanguageMenu = ({ lang }: LanguageMenuProps) => {
  const [selectedLanguage, setSelectedLanguage] = useOptimistic(lang)
  const [isPending, startTransition] = useTransition()
  const dict = useDictionary()

  const handleSelect = (value: Language) => {
    startTransition(async () => {
      setSelectedLanguage(value)
      await setLanguage(value)
    })
  }

  return (
    <Select value={selectedLanguage} onValueChange={handleSelect}>
      <SelectTrigger className="flex w-11 items-center gap-2 border-0 bg-transparent p-0 uppercase text-black">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>{dict.languages}</SelectLabel>
          {languages.map((lang) => (
            <SelectItem key={lang} value={lang} className="uppercase">
              {lang}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default LanguageMenu
